export const HERO_PARALLAX_DRIFT_RATIO = 0.1;
export const HERO_PARALLAX_SCRUB = 1;

export function getVisibleHeroImage(root: HTMLElement): HTMLImageElement | null {
    const images = Array.from(root.querySelectorAll("img"));

    return images.find((image) => image.offsetParent !== null) ?? images[0] ?? null;
}

export function getHeroCoverAspectRatio(image: HTMLImageElement): string | null {
    if (image.naturalWidth <= 0 || image.naturalHeight <= 0) {
        return null;
    }

    return `${image.naturalWidth} / ${image.naturalHeight}`;
}

export function getAvailableUpwardTravel(
    mediaHeight: number,
    clipHeight: number
): number {
    return Math.max(0, (mediaHeight - clipHeight) / 2);
}

export function getHeroParallaxTravel(
    heroHeight: number,
    availableOverflow = Number.POSITIVE_INFINITY
): number {
    if (heroHeight <= 0 || availableOverflow <= 0) {
        return 0;
    }

    return Math.min(heroHeight * HERO_PARALLAX_DRIFT_RATIO, availableOverflow);
}

export function syncHeroCoverMedia(media: HTMLElement): void {
    const image = getVisibleHeroImage(media);
    const aspectRatio = image ? getHeroCoverAspectRatio(image) : null;

    if (!aspectRatio) {
        media.style.removeProperty("aspect-ratio");
        return;
    }

    media.style.aspectRatio = aspectRatio;
}
